const mediaItems = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    category: '科幻大片',
    desc: '浩瀚宇宙中的终极冒险，视觉特效全面升级',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20image%20with%20dramatic%20lighting%20and%20warm%20tone%2C%20professional%20film%20aesthetic%2C%20dark%20background%20with%20vibrant%20accent%20colors%2C%20minimalist%20composition%2C%20no%20text%20no%20people&width=400&height=600&seq=media-01&orientation=portrait',
  },
  {
    id: 2,
    title: '古城谜案',
    category: '悬疑推理',
    desc: '千年古城隐藏的惊天秘密，步步惊心',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20movie%20poster%20with%20dark%20alleyways%20and%20warm%20amber%20streetlights%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20golden%20highlights%2C%20professional%20cinema%20style%2C%20no%20text%20no%20people&width=400&height=600&seq=media-02&orientation=portrait',
  },
  {
    id: 3,
    title: '热血拳王',
    category: '动作励志',
    desc: '从街头到擂台的无名英雄逆袭之路',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20action%20movie%20poster%20with%20intense%20red%20and%20crimson%20tones%2C%20fighter%20silhouette%20in%20spotlight%2C%20dynamic%20energy%2C%20professional%20boxing%20film%20aesthetic%2C%20dark%20background%2C%20no%20text%20no%20people&width=400&height=600&seq=media-03&orientation=portrait',
  },
  {
    id: 4,
    title: '深海奇缘',
    category: '动画奇幻',
    desc: '深海世界的奇妙旅程，全年龄段治愈之作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dreamy%20animated%20movie%20poster%20with%20deep%20ocean%20blue%20and%20teal%20tones%2C%20bioluminescent%20underwater%20world%2C%20magical%20atmosphere%2C%20soft%20glowing%20particles%2C%20fantasy%20film%20aesthetic%2C%20no%20text%20no%20people&width=400&height=600&seq=media-04&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">精彩预告</h2>
          <p className="text-sm text-foreground-500">本周最受期待的影片，精彩不容错过</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-foreground-950 mb-1.5">
                    {item.category}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}